// extracted by mini-css-extract-plugin
export default {"backdrop":"SharedFilesModal_backdrop__2NFqC","card":"SharedFilesModal_card__J+J1O","close":"SharedFilesModal_close__0aCo+"};